var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2247",
    "data-name": "Group 2247",
    transform: "translate(-30 -240)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(30 240)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2241",
    "data-name": "Group 2241",
    transform: "translate(-1.247 2.573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2216",
    "data-name": "Group 2216",
    transform: "translate(37 246.427)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    x2: 1.5,
    transform: "translate(1.247)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x2: 6.994,
    transform: "translate(4.747)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x2: 10.494,
    transform: "translate(1.247 3.708)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    x2: 10.494,
    transform: "translate(1.247 7.416)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionHistory);
export default __webpack_public_path__ + "static/media/transaction-history.747b0147afd184d3c747003c8b9fd43e.svg";
export { ForwardRef as ReactComponent };